import React, { Component } from "react";
import NavbarDefault from "../components/NavbarDefault/NavbarDefault";

import SingleProgram from "../components/SingleProgram/SingleProgram";
import HamatLogo from "../assets/img/programs/hamat-lg.png";
import SignUpBtn from "../assets/img/programs/sign-up-btn.svg";

const program = {
  programId: "program-hamat",
  programLogo: HamatLogo,
  programDescription:
    "هامات هو مشروع لتطوير قيادات التحول الرقمي في القطاع الحكومي في المملكة العربية السعودية. يتكون المشروع من عدة مسارات تعليمية تركز على القيادة التقنية، قيادة الأعمال، قيادة الابتكار وتصميم الخدمات، والاستشارات الرقمية.",
  programClassName: "program-hamat",
  programLists: [
    {
      programPathLabel: "المسار",
      programPathNumber: 1,
      programPathTitle: "قيادة الأعمال",
      programPathList: [
        "برنامج دولي في ريادة الأعمال.",
        "برنامج إدارة التغيير PROSCI.",
        "ورشة عمل دولية.",
        "مشروع سفير ريادة أعمال حكومي."
      ]
    },
    {
      programPathLabel: "المسار",
      programPathNumber: 2,
      programPathTitle: "تقنية المعلومات",
      programPathList: [
        "برنامج دولي في مجال تقنية المعلومات.",
        "برنامج إدارة التغيير PROSCI.",
        "ورشة عمل دولية.",
        "مشروع سفير تحول رقمي حكومي."
      ]
    },
    {
      programPathLabel: "المسار",
      programPathNumber: 3,
      programPathTitle: "الإبتكار والتصميم",
      programPathList: [
        "برنامج دولي في مجال الابتكار وتصميم الخدمات الرقمية.",
        "برنامج إدارة التغيير PROSCI.",
        "ورشة عمل دولية.",
        "مشروع سفير الابتكار وتصميم الخدمات."
      ]
    },
    {
      programPathLabel: "المسار",
      programPathNumber: 4,
      programPathTitle: "الإستشارات الرقمية",
      programPathList: [
        "برنامج دولي في الاستشارات الرقمية.",
        "برنامج إدارة التغيير PROSCI.",
        "زيارة رسمية حكومية لعدد من المرشحين من المسار.",
        "مشروع سفير استشارات رقمية حكومي."
      ]
    }
  ],
  SignUpBtn: SignUpBtn
};

export default class HamatProgram extends Component {
  
  render() {
    return (
      <>
        {/* <Navbar /> */}
        <NavbarDefault />
        <SingleProgram program={program} />
        {/* <Footer /> */}
      </>
    );
  }
}
